module.exports = __webpack_public_path__ + "img/user.d831f21c.png";